import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCategoryCareAndSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 6.375C15 10.75 8.51312 14.2913 8.23687 14.4375C8.16406 14.4767 8.08268 14.4972 8 14.4972C7.91732 14.4972 7.83594 14.4767 7.76312 14.4375C7.48688 14.2913 1 10.75 1 6.375C1.00116 5.34764 1.40979 4.36269 2.13624 3.63624C2.86269 2.90979 3.84764 2.50116 4.875 2.5C6.16563 2.5 7.29562 3.055 8 3.99312C8.70438 3.055 9.83438 2.5 11.125 2.5C12.1524 2.50116 13.1373 2.90979 13.8638 3.63624C14.5902 4.36269 14.9988 5.34764 15 6.375Z",
		fill: "current"
	})
});
export default SvgCategoryCareAndSupport;
